import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LicenseFrameworkNoticeComponent } from './license-framework-notice.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { CygovButtonModule } from '../cygov-button/cygov-button.module';

@NgModule({
  declarations: [LicenseFrameworkNoticeComponent],
  imports: [CommonModule, FormsModule, SvgIconModule, CygovButtonModule],
  exports: [LicenseFrameworkNoticeComponent],
})
export class LicenseFrameworkNoticeModule {}
